import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import axios from 'axios';
import {  apiUrl,productURL} from '../Config/Config';
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import { GET_VIEWDOCTORLIST } from '../../actions';
import { mediaUrl} from'../Config/Config';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import moment from 'moment';
class ViewEMR extends Component {

  constructor(props)
  {
    super(props); 
    const userid = (typeof this.props.match.params.ID === 'undefined') ? '' : this.props.match.params.ID;
    this.state = {      
      userid: userid,
      doctorlistview:'',
      familtlistview:'',
      pastappointment:[],
      ongoingappts:[],
      futureappts:[],
      pastappointmentcount:0,
      ongoingapptscount:0,
      futureapptscount:0,

      activetab: 'userdetail',  
      ShowFamilyDocuments:false,
      FamilyDocuments:'',
      medicalHistorylist:'',
      medicalCondition:'',
      ShowPrescriptionlist:'',
      Prescriptionlist:'',
      RaiseDisputelist:'',
      recommendedlist:'',
      ratinglist:'',
      ShowRecommendedProduct:false,
      recommendedProductlist:'',
      revenuelist:'',
      technicianlist:'',
      isActive:true,
      activePage:1,
    };

    // var qs = require('qs');
    // var postObject = {             
    // id   :userid
    // };
    // this.props.getViewDoctorList(qs.stringify(postObject));  
  }

   
   componentDidMount() {
  

    
    var qs = require('qs');
    var postObject = {     
      activePage: 1,      
      id   :this.state.userid
    };
    axios.post(apiUrl+"doctor/emrview",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){ 
        this.setState({doctorlistview: res.data.doctorlist});
   
        this.setState({pastappointment: res.data.pastappointment,pastappointmentcount: res.data.pastappointmentcount},function(){
          this.pastappointment();
        });
        this.setState({ongoingappts: res.data.ongoingappts,ongoingapptscount: res.data.ongoingapptscount},function(){
          this.ongoingappts();
        });
        this.setState({futureappts: res.data.futureappts,futureapptscount: res.data.futureapptscount},function(){
          this.futureappts();
        });
        this.setState({recommendedlist: res.data.recommendedlist},function(){
          this.recommendedlist();
        });
  
        this.setState({RaiseDisputelist:res.data.raise_dispute},function(){
          this.RaiseDisputelist();
        }) 
        this.setState({ratinglist:res.data.doctorrating},function(){
          this.Ratinglist();
        }) 
        this.setState({revenuelist:res.data.revenue_list},function(){
          this.Revenuelist();
        })
        this.setState({technicianlist:res.data.techlist},function(){
          this.technicianlist();
        }) 
  
        
        
  
      //   this.setState({medicalHistorylist:res.data.usermedicalfiles},function(){
      // this.medicalHistory();
      //   }) 
      
      //   this.setState({medicalCondition:res.data.medicalcondition},function(){
      //     this.medicalCondition();
      //   })

      }
    }); 
     document.title = PageTitle('Vet View');
     if ($('.sidebar-menu').hasClass('menu-close')) {
          $('.sidebar-menu').removeClass('menu-close');
          $('.logo-box').removeClass('active');	
            $('.header-cnt-left').removeClass('toggle-open');
      }else{
          $('.sidebar-menu').addClass('menu-close');
          $('.logo-box').addClass('active');
            $('.header-cnt-left').addClass('toggle-open');
    }
  }

   componentDidUpdate(prevProps,prevState){

   }
   technicianlist = ()=>{
    var technicianlist = this.state.technicianlist;
    if (technicianlist != "undefined" && technicianlist != null) {
      // if ( == "success"){
        if (Object.keys(technicianlist).length > 0) {
          const telist = technicianlist.map(
            (list, Index) => {
              let sno = Index+1;
            
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{list.name} {list.graduation?'('+list.graduation+')':''}</td>
                 <td>{list.email?list.email:'N/A'}</td>
                 <td>{list.phone?list.phone:'N/A'}</td>
                 <td>{list.experience_yr?list.experience_yr:'N/A'}</td>  
                 <td>{list.location?list.location:'N/A'}</td>   
                </tr>
              );
            }
          );
          return telist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
   }
  pastappointment() {
    var appointments = this.state.pastappointment;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 
                
                  <td>
                  {appts.name}
                  </td>
                  <td>
                  {appts.petname}
                  </td>
                  <td>
                  {appts.petvisit}
                  </td>
                  <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                  {/* <td>
                  {appts.gender}
                  </td> */}
                 
                  {/* <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td> */}

                  <td>
                  {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:'N/A'}
                 </td>
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }

  ongoingappts() {
    var appointments = this.state.ongoingappts;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
               
                  <td>
                  {appts.name}
                  </td> 
                  <td>
                  {appts.petname}
                  </td>
                
                  <td>
                  {appts.petvisit}
                  </td>

                  <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                  {/* <td>
                  {appts.gender}
                  </td>
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td> */}
                  <td>
                    {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:'N/A'}

                    
                  </td>
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
  apptPrescriptionShow = (preslist)=>{
    this.setState({ShowPrescriptionlist:true,Prescriptionlist:preslist});
  }

  recommendedProductShow = (list)=>{
    this.setState({ShowRecommendedProduct:true,recommendedProductlist:list});
  }
  recommendedProductlist = ()=>{ 
    var preslist = this.state.recommendedProductlist;
    if (preslist != "undefined" && preslist != null) {
      // if ( == "success"){
        if (Object.keys(preslist).length > 0) {
          const apptDlist = preslist.map(
            (data, Index) => {
              let sno = Index+1;            
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{data.p_name}</td>
                 <td>{data.product_catname}</td>
                 <td>{(data.image!=''&&data.image!=null)&&<img src={productURL+'/'+data.image} alt={data.p_name}  width="150" height="150" />}</td>                
                 <td>${data.single_price}</td>
                 <td>{data.quantity}</td>
                 <td>${data.total_price}</td>                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
    
  }
  apptPrescriptionlist = (preslist)=>{
 
    var preslist = this.state.Prescriptionlist;
    if (preslist != "undefined" && preslist != null) {
      // if ( == "success"){
        if (Object.keys(preslist).length > 0) {
          const apptDlist = preslist.map(
            (data, Index) => {
              let sno = Index+1;
            
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{data.prescription_name}</td>
                 <td>{data.quantity}</td>
                 <td>${data.price}</td>
                 {/* <td>{data.created_on}</td> */}
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
    
  }
  futureappts() {
    var appointments = this.state.futureappts;
    if (appointments != "undefined" && appointments != null) {
      // if ( == "success"){
        if (Object.keys(appointments).length > 0) {
          const apptDlist = appointments.map(
            (appts, Index) => {
              let sno = Index+1;
              var apptstatus = 'Pending';
              if(appts.paid_status =='booked'){
                var apptstatus = 'Accepted'
              }else  if(appts.paid_status =='paid'){
                var apptstatus = 'Completed'
              }
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td>{appts.appointment_id}</td>
                 
                  <td>
                  {appts.name}
                  </td>
                  <td>
                  {appts.petname}
                  </td>
                
                  <td>
                  {appts.petvisit}
                  </td>
                  <td>{moment(appts.appointment_date).format('MMM DD Y hh:mm A')}</td>
                
                  {/* <td>
                  {appts.gender}
                  </td>
                 
                  <td>
                  {appts.phone}
                  </td>
                  <td>
                    {apptstatus}
                  </td> */}
                  {/* <td> */}
                    {/* {appts.prescriptionlist.length>0?
                    <a class="" title="View" href="#" onClick={this.apptPrescriptionShow.bind(this,appts.prescriptionlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:''} */}

                    
                  {/* </td> */}
                 
                </tr>
              );
            }
          );
          return apptDlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }
    
    }
  }
//   medicalCondition = ()=>{
//     var medicalCondition = this.state.medicalCondition;
//     if (medicalCondition != "undefined" && medicalCondition != null) {
//       // if ( == "success"){
//         if (Object.keys(medicalCondition).length > 0) {
//           const medlist = medicalCondition.map(
//             (data, Index) => {
//               let sno = Index+1;
              
//               return (
//                 <tr key={Index}>
// 				         <td>{sno}</td>
//                  <td> <p>  {data.medical_condition} </p></td>
//                  <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>
                 
                 
//                 </tr>
//               );
//             }
//           );
//           return medlist;
//         }
//       else {
//         return (
//           <tr>
//             <td colSpan="9" className="v-align-nr text-center">
//               No Result
//             </td>
//           </tr>
//         );
//       }
    
//     }
//   }
//   medicalHistory = ()=>{

//     var medicalHistorylist = this.state.medicalHistorylist;
//     if (medicalHistorylist != "undefined" && medicalHistorylist != null) {
//       // if ( == "success"){
//         if (Object.keys(medicalHistorylist).length > 0) {
//           const medlist = medicalHistorylist.map(
//             (medicalfile, Index) => {
//               let sno = Index+1;
              
//               return (
//                 <tr key={Index}>
// 				         <td>{sno}</td>
//                  <td> <p> <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="10.79 5 78.42 90" onClick={() => this.downloadImage(mediaUrl+"familymedical/"+medicalfile.image,medicalfile.image)} style={{width: '30px',height: '30px'}}
//  > <g data-name="pdf"><path d="M87,25.34,70.92,7.75A8.46,8.46,0,0,0,64.69,5H19.23a8.45,8.45,0,0,0-8.44,8.44V86.56A8.45,8.45,0,0,0,19.23,95H80.77a8.45,8.45,0,0,0,8.44-8.44V31A8.4,8.4,0,0,0,87,25.34Zm-5.33,2.51H71.31A2.82,2.82,0,0,1,68.5,25V13.44Zm-.9,61.53H19.23a2.82,2.82,0,0,1-2.82-2.82V13.44a2.82,2.82,0,0,1,2.82-2.82H62.87V25a8.45,8.45,0,0,0,8.44,8.44H83.59V86.56A2.82,2.82,0,0,1,80.77,89.38Z"/><path d="M67.22,28.89,66.5,9H14.67V91.33H85.5V29.12ZM40.4,53.48a6.21,6.21,0,0,1-1.79,2.22A7.6,7.6,0,0,1,36,57a11.54,11.54,0,0,1-3.16.42H31.17a1,1,0,0,0-.94.94v5.24a.94.94,0,0,1-.94.94H26.44a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h6.27a14.69,14.69,0,0,1,3.26.34A7.33,7.33,0,0,1,38.61,45a5.54,5.54,0,0,1,1.79,2.09,7.06,7.06,0,0,1,.66,3.21A7.24,7.24,0,0,1,40.4,53.48Zm18.73,5.15A8.69,8.69,0,0,1,57,61.93a8.58,8.58,0,0,1-3.24,2,12.9,12.9,0,0,1-4.2.65H44.35a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94h5a14.65,14.65,0,0,1,4.35.61A8.78,8.78,0,0,1,57,46a8.28,8.28,0,0,1,2.12,3.24,13.07,13.07,0,0,1,.75,4.67A13.36,13.36,0,0,1,59.13,58.63ZM75.82,46.58a.94.94,0,0,1-.94.94H68.26a.94.94,0,0,0-.94.94v3a.94.94,0,0,0,.94.94h5.4a.94.94,0,0,1,.94.94v2.12a.94.94,0,0,1-.94.94h-5.4a.94.94,0,0,0-.94.94v6.27a.94.94,0,0,1-.94.94H63.52a.94.94,0,0,1-.94-.94V44.46a.94.94,0,0,1,.94-.94H74.88a.94.94,0,0,1,.94.94Z"/><path d="M53.37,48.76a4.33,4.33,0,0,0-1.87-1.08,8.5,8.5,0,0,0-2.45-.32h-.9V60.69h.9a7.84,7.84,0,0,0,2.45-.35,4.65,4.65,0,0,0,1.87-1.14,5.6,5.6,0,0,0,1.21-2.08A10.08,10.08,0,0,0,55,53.93a9.8,9.8,0,0,0-.43-3.14A5.23,5.23,0,0,0,53.37,48.76Z"/><path d="M35.39,48a5.42,5.42,0,0,0-3-.68H31.17a1,1,0,0,0-.94.94V52.7a1,1,0,0,0,.94.94h1.38q3.87,0,3.87-3.35A2.55,2.55,0,0,0,35.39,48Z"/></g></svg>  {medicalfile.image} </p></td>
//                  <td>{moment(medicalfile.created_on).format('MMM DD Y hh:mm A')}</td>
                 
                 
//                 </tr>
//               );
//             }
//           );
//           return medlist;
//         }
//       else {
//         return (
//           <tr>
//             <td colSpan="9" className="v-align-nr text-center">
//               No Result
//             </td>
//           </tr>
//         );
//       }
    
//     }

//   }

  RaiseDisputelist = ()=>{
    
    var RaiseDisputelist = this.state.RaiseDisputelist;
    if (RaiseDisputelist != "undefined" && RaiseDisputelist != null) {
      // if ( == "success"){
        if (Object.keys(RaiseDisputelist).length > 0) {
          const medlist = RaiseDisputelist.map(
            (data, Index) => {
              let sno = Index+1;
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p>  {data.dispute} </p></td>
                 <td> <p>  {data.appointment_id} </p></td>
                 <td> <p>  {data.firstname} {(data.lastname!=''&&data.lastname!=null)&&data.lastname}</p></td>
                 <td> <p>  {data.dispute_message} </p></td>
                 {/* <td> <p>  {data.dispute_status=='A'?'Active':'Inactive'}</p></td> */}
                 
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>
                                  
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }    
    }
  }

  
  Ratinglist = ()=>{
    
    var ratinglist = this.state.ratinglist;
    if (ratinglist != "undefined" && ratinglist != null) {
      // if ( == "success"){
        if (Object.keys(ratinglist).length > 0) {
          const medlist = ratinglist.map(
            (data, Index) => {
              let sno = Index+1;
              return (
                <tr key={Index}>
				         <td>{sno}</td>                
                 <td> <p>  {data.appointment_id} </p></td>
                 <td> <p>  {data.firstname} </p></td>
                 <td> <p>  {data.rating}/5 </p></td>
                 <td> <p>  {data.rating_message} </p></td>                 
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>                                  
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }    
    }
  }

  recommendedlist = ()=>{
    var recommendedlist = this.state.recommendedlist;
    if (recommendedlist != "undefined" && recommendedlist != null) {
      // if ( == "success"){
        if (Object.keys(recommendedlist).length > 0) {
          const medlist = recommendedlist.map(
            (data, Index) => {
              let sno = Index+1;
              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p>  {data.firstname} </p></td>
                 <td> <p>  {data.product_count} </p></td>
                 <td> <p>  ${data.total_amt} </p></td>   
                 <td> <p>  {data.pay_status} </p></td>   
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>
                 <td>
                    {data.productlist.length>0?
                    <a class="" title="View" href="#" onClick={this.recommendedProductShow.bind(this,data.productlist)}>  <i class="ft-eye" aria-hidden="true"></i></a>:''}

                 </td>
                                  
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }    
    }
  }

  Revenuelist = ()=>{
    
    var revenuelist = this.state.revenuelist;
    if (revenuelist != "undefined" && revenuelist != null) {
      // if ( == "success"){
        if (Object.keys(revenuelist).length > 0) {
          const medlist = revenuelist.map(
            (data, Index) => {
              let sno = Index+1;              
              return (
                <tr key={Index}>
				         <td>{sno}</td>
                 <td> <p>  {data.appt!=null?'Appointments':'Orders'} </p></td>
                 <td> <p>  {data.appt!=null?data.appt:'#uxt00'+data.order_id} </p></td>
                 {/* <td> <p>  {data.user_fname!=null&&data.user_fname} </p></td>    */}
                 <td> <p>  ${(data.revenue&&data.appt_revenue)?parseInt(data.revenue)+parseInt(data.appt_revenue):data.appt_revenue!=null?data.appt_revenue:data.revenue} </p></td>   
                 {/* <td> <p>  {data.settlement} </p></td>    */}
                 <td>{moment(data.created_on).format('MMM DD Y hh:mm A')}</td>  
                </tr>
              );
            }
          );
          return medlist;
        }
      else {
        return (
          <tr>
            <td colSpan="6" className="v-align-nr text-center">
              No Result
            </td>
          </tr>
        );
      }    
    }
  }

  handleGoBack = () => {
    if(this.state.ShowPrescriptionlist){
      this.setState({ShowPrescriptionlist:false});
    }else if(this.state.ShowRecommendedProduct){
      this.setState({ShowRecommendedProduct:false});
    }else{
      this.props.history.goBack();
    }
    
  }
  handleClick = (index) => {
    this.setState({ activetab: index,ShowPrescriptionlist:false ,activePage:1});
  };
  expandClick = () => {
    this.setState({ isActive: !this.state.isActive });
  };
  Capitalize(str){
    if (!str || typeof str !== "string") return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
    }
    ShowFamilyDocuments=(documents)=>{
      this.setState({ShowFamilyDocuments:true,FamilyDocuments:documents});
    }
    downloadImage(url, name) {
			fetch(url)
			.then(resp => resp.blob())
			.then(blob => {
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.href = url;
				link.download = name;
				document.body.appendChild(link);
				link.click();
				window.URL.revokeObjectURL(url);
			})
			.catch(() => alert('An error sorry'));
		}
      handlePageChange(type,pageNumber) {
        // console.log(`active page is ${pageNumber}`);
         this.setState({activePage: pageNumber});
    

      var qs = require('qs');
      var postObject = {     
        activePage:pageNumber,      
        id   :this.state.userid
      };
      axios.post(apiUrl+"doctor/emrview",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){ 
          // this.setState({doctorlistview: res.data.doctorlist});
          if(type=='past')
          {            
            this.setState({pastappointment: res.data.pastappointment,pastappointmentcount: res.data.pastappointmentcount},function(){
              this.pastappointment();
            });
          }else if(type=='ongoing')
            {
          this.setState({ongoingappts: res.data.ongoingappts,ongoingapptscount: res.data.ongoingapptscount},function(){
            this.ongoingappts();
          });
        }if(type=='future')
          {
          this.setState({futureappts: res.data.futureappts,futureapptscount: res.data.futureapptscount},function(){
            this.futureappts();
          });
        }
          // this.setState({recommendedlist: res.data.recommendedlist},function(){
          //   this.recommendedlist();
          // });
    
          // this.setState({RaiseDisputelist:res.data.raise_dispute},function(){
          //   this.RaiseDisputelist();
          // }) 
          // this.setState({ratinglist:res.data.doctorrating},function(){
          //   this.Ratinglist();
          // }) 
          // this.setState({revenuelist:res.data.revenue_list},function(){
          //   this.Revenuelist();
          // })
          // this.setState({technicianlist:res.data.techlist},function(){
          //   this.technicianlist();
          // }) 
    
          
          
    
        //   this.setState({medicalHistorylist:res.data.usermedicalfiles},function(){
        // this.medicalHistory();
        //   }) 
        
        //   this.setState({medicalCondition:res.data.medicalcondition},function(){
        //     this.medicalCondition();
        //   })
  
        }
      }); 
    }
  render() {
    const { activetab } = this.state;
     if((this.state.doctorlistview.subscribed_plan_name!='')&&(this.state.doctorlistview.subscribed_plan_name!=null)){
        if(this.state.doctorlistview.subscribed_plan_name == "Free"){

         var plan_paid_amount = "$"+0;
        }else{
           var plan_paid_amount = "$"+this.state.doctorlistview.plan_paid_amount;
        }
    }else{
     var plan_paid_amount = "N/A";
    }

    if((this.state.doctorlistview.subscribed_plan_name!='')&&(this.state.doctorlistview.subscribed_plan_name!=null)){
        var subscribed_plan_name = this.state.doctorlistview.subscribed_plan_name;
    }else{
     var subscribed_plan_name = "N/A";
    }


    if((this.state.doctorlistview.transactionId!='')&&(this.state.doctorlistview.transactionId!=null)){
        var transactionId = this.state.doctorlistview.transactionId;
    }else{
     var transactionId = "N/A";
    }

    var mobileno = ((this.state.doctorlistview.mobileno === null)||((this.state.doctorlistview.mobileno === ''))) ?  this.state.doctorlistview.mobileno = 'N/A' : this.state.doctorlistview.mobileno;

    var lastname = ((this.state.doctorlistview.lastname === null)||(this.state.doctorlistview.lastname === "")) ?  this.state.doctorlistview.lastname = 'N/A' : this.state.doctorlistview.lastname;


    return (
      <div className="wrapper"> 
 
    <Header />
    <MenuSidebar currentpage="doctors" />  
      
      <div className="content"> 
        <div className="content-wrapper">
         <div class="content-wrapper-before"></div>
            <div className="content-body">
               <div className="form-wrapper leaa-admin-head card">
                 <div>
                  <span className='cursor-pointer btn-arrow end' onClick={this.handleGoBack}><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800.48 613.46"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(-1 0 0 -1 800.48 613.46)"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -199.77 906.72003)"><path d="m857.14 640.38-221.02 225.27-4.25-665.88-65.172 1.4141-1.418 667.3-223.85-226.68-48.172 48.172 306.02 310.27 307.44-311.69z" fillRule="evenodd"/></g></g></svg></span> 
               </div>
               <div className={`${this.state.isActive ? "vertical-menu-bar active" : "vertical-menu-bar"}`} onClick={this.expandClick}>
               {/* <svg version="1.1" x="0px" y="0px" viewBox="8 18 84 64" onClick={this.expandClick}><g transform="translate(0,-952.36218)"><path d="m 13,970.36219 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5 0,2.76149 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.23851 5,-5 0,-2.7615 -2.2386,-5 -5,-5 z m 0,26.99998 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5.00003 0,2.7615 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.2385 5,-5 0,-2.76153 -2.2386,-5.00003 -5,-5.00003 z m 0,27.00003 c -2.7614,0 -4.9999999,2.2385 -4.9999999,5 0,2.7615 2.2385999,5 4.9999999,5 l 74,0 c 2.7614,0 5,-2.2385 5,-5 0,-2.7615 -2.2386,-5 -5,-5 z" fill="#000000" fill-opacity="1" stroke="none" marker="none" visibility="visible" display="inline" overflow="visible"></path></g></svg> */}
               <div>
               <h4>Vet</h4>
               <div>
               <span className="icon_menu1"></span>
                    <span className="icon_menu2"></span>
                    <span className="icon_menu3"></span>
                    </div>
                    </div>
               </div>
               <div className='title text-start mt-20px pb-0'>
               <h3>{this.Capitalize(this.state.doctorlistview.name)}'s Profile</h3>
                </div> 
                
               <div className='d-flex w-100 gap-4 vertical-menu-content-wrapper mt-4 min-vh-100'>
                <ul  className={`${this.state.isActive ? "vertical-menu-list active" : "vertical-menu-list"}`}>

                  <li onClick={() => this.handleClick('userdetail')} className={activetab === 'userdetail' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="5 3 22 26"><path d="M11,29H21a6,6,0,0,0,0-12H11a6,6,0,0,0,0,12Z"/><circle cx="16" cy="9" r="6"/></svg>
                     <span>Demographics</span><span class="tooltip">Demographics</span></li>

                     
                  <li onClick={() => this.handleClick('technicianlist')} className={activetab === 'technicianlist' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="5.08 5.08 91.41 89.85">  <path d="m15.598 91.469-2.3594-1.1797c-0.13281-0.066406-0.21484-0.20312-0.21484-0.35156v-8.9531c0-0.14844 0.082031-0.28516 0.21484-0.35156l7.9219-3.9609v0.003906c3.8047-1.8906 6.207-5.7734 6.1914-10.02 0-0.21875 0.17578-0.39062 0.39063-0.39062 4.7734-0.003906 9.4805 1.1094 13.746 3.2422l3.3789 1.6875v0.003907c2.2383 1.1172 4.6562 1.8281 7.1406 2.0977 1.0664-1.3438 2.3164-2.5352 3.7148-3.5312v-0.011719l0.28906-4.9141c0.015625-0.21484 0.19922-0.375 0.41406-0.36328 0.21484 0.011719 0.37891 0.19531 0.36719 0.41016l-0.25391 4.3359v-0.003906c1.1328-0.71875 2.3438-1.3125 3.6133-1.7656l9.8008-3.5 1.3359-12.027v0.003907c0.046876-0.44141 0.36719-0.80078 0.79297-0.90234 0.42969-0.10547 0.875 0.070312 1.1211 0.43359l2.0078 3.0117h0.21875l1.1406-5.1289-0.003906 0.003906c0.60938-2.7461 2.7852-4.875 5.5469-5.4258l6.5938-1.3203c2.4336-0.49219 4.5234-2.0391 5.707-4.2227-0.96484-0.046875-1.832-0.60156-2.2773-1.4609-0.44141-0.85938-0.39453-1.8867 0.125-2.6992l-7.2656-1.2109c-0.10547-0.019531-0.20312-0.082031-0.26172-0.17187l-0.64844-0.98047c-1.375-2.082-3.6992-3.3359-6.1914-3.3398-0.21484 0-0.39062-0.17578-0.38672-0.39062v-5.1328c0-0.33594-0.23047-0.625-0.55469-0.70703-0.32031-0.078125-0.66016 0.074219-0.8125 0.36719-1.3164 2.5039-7.9375 15.125-9.2578 17.543-1.4766 2.707-3.6523 4.9648-6.3008 6.5352-2.6484 1.5742-5.668 2.4023-8.75 2.4023h-15.133c-0.023438 0-0.042969 0-0.0625-0.003906l-5.5234-0.92188c-3.3164-0.55859-6.7188-0.046875-9.7227 1.4609l-0.17969 0.089843c-1.0156 0.50781-1.9766 1.1211-2.8711 1.8242-0.089844 0.070313-0.20312 0.097657-0.3125 0.078125-0.10938-0.019531-0.20703-0.089844-0.26562-0.18359l-1.8828-3.1406c-0.58203-0.94922-0.93359-2.0195-1.0391-3.1289-0.16406-1.9727 0.51172-3.9219 1.8633-5.3672 1.3477-1.4492 3.2461-2.2578 5.2227-2.2344 2.1016 0.042969 4.0469 1.1211 5.1992 2.8828l0.25 0.375c0.20703 0.30859 0.52734 0.52734 0.89062 0.60156 0.36719 0.074218 0.74609 0 1.0547-0.20703 0.3125-0.20703 0.52734-0.52734 0.59766-0.89453 0.074219-0.36328-0.003907-0.74219-0.21094-1.0547l-0.30078-0.45312c-1.6875-2.5352-4.5312-4.0547-7.5781-4.0508-2.7344 0.003906-5.3438 1.1484-7.2031 3.1562-1.8711 2.0078-2.8086 4.7109-2.582 7.4453 0.13672 1.5508 0.63281 3.0508 1.4414 4.3828l2.3203 3.8672c0.085937 0.14062 0.070312 0.32031-0.035157 0.44922-2.4219 2.9648-3.75 6.6758-3.7578 10.508v5.9805c0.003906 2.1445-1.0703 4.1484-2.8555 5.3398-0.003906 0.003906-0.011719 0.007812-0.015625 0.011718h-0.003906c-1.5625 1.0469-2.5 2.8047-2.4961 4.6875v13.785-0.003907c0 0.28125 0.22656 0.50781 0.50781 0.50781h7.5703c0.89844 0.015625 1.6797-0.60938 1.8555-1.4883 0.14844-0.80078-0.25-1.6016-0.97656-1.9648z"></path>  <path d="m45.398 80.977-1.1289 1.1289c-1.0469 1.043-1.6484 2.4492-1.6914 3.9258-0.042969 1.4648 0.50781 2.8867 1.5273 3.9375 1.0469 1.0664 2.4492 1.7109 3.9414 1.8086v-7.1484c0.003906-3.8086 1.1992-7.5195 3.418-10.609-1.9414-0.25391-3.8359-0.76953-5.6406-1.5273 0.97266 1.1641 1.4805 2.6445 1.4375 4.1602-0.042969 1.625-0.71094 3.1758-1.8633 4.3242z"></path>  <path d="m30.055 38.422 0.30078 0.45312v0.003906c0.32812 0.48047 0.44531 1.0703 0.33594 1.6406-0.11328 0.57031-0.44922 1.0742-0.93359 1.3945-0.48437 0.32422-1.0742 0.4375-1.6445 0.32422-0.57031-0.11719-1.0703-0.45703-1.3867-0.94141l-0.25-0.375h-0.003906c-1.0078-1.5469-2.7148-2.4961-4.5586-2.5352-1.7578-0.019531-3.4414 0.69922-4.6406 1.9805-1.207 1.2852-1.8086 3.0195-1.6562 4.7773 0.09375 0.98828 0.41016 1.9414 0.92969 2.7891l1.6602 2.7656c0.83594-0.625 1.7227-1.1719 2.6562-1.6406l0.17969-0.089844c3.1484-1.582 6.7227-2.1211 10.195-1.5312l5.4922 0.91406h15.102c2.9414 0 5.8242-0.78906 8.3516-2.293 2.5273-1.5 4.6055-3.6562 6.0117-6.2344 0.4375-0.80469 1.4648-2.7422 2.6914-5.0586h-3.2617c-0.21484 0-0.39062-0.17578-0.39062-0.39062v-29.297h-30.469v29.297c0 0.10547-0.042969 0.20312-0.11328 0.27734-0.074219 0.070312-0.17188 0.11328-0.27734 0.11328h-8.7891c1.8203 0.74609 3.3789 2.0195 4.4688 3.6562z"></path>  <path d="m21.512 77.371-7.707 3.8516v8.4727l2.1445 1.0703v0.003906c1.0352 0.51953 1.6055 1.6641 1.3945 2.8047-0.09375 0.51172-0.34375 0.98047-0.71484 1.3477h3.5273c0.84766 0 1.582-0.58203 1.7773-1.4023 0.19141-0.82422-0.20312-1.6719-0.96094-2.0508l-2.3594-1.1797c-0.13281-0.066406-0.21484-0.20312-0.21484-0.35156v-7.1641c0-0.15625 0.089843-0.29297 0.23047-0.35547l4.707-2.0938c5.2852-2.3633 9.1953-7.0156 10.617-12.629-1.918-0.40625-3.8672-0.62109-5.8242-0.64844-0.12891 4.3984-2.6758 8.3711-6.6172 10.324z"></path>  <path d="m11.234 64.613c0.003906-3.918 1.3281-7.7188 3.7578-10.789l-2.1797-3.6328c-0.87109-1.4336-1.4023-3.0508-1.5469-4.7227-0.24609-2.9531 0.76562-5.8711 2.7852-8.0352 1.0859-1.1719 2.418-2.082 3.9062-2.668h-12.879v30.469h6.1562z"></path>  <path d="m94.551 33.738c-1.0664 0-1.9336 0.86328-1.9336 1.9336 0 1.0664 0.86719 1.9336 1.9336 1.9336 0.17188-0.003907 0.33984-0.027344 0.50781-0.0625 0.17578-0.046875 0.34766-0.12109 0.5-0.22266 0.73828-0.45312 1.0898-1.3398 0.85547-2.1758-0.23437-0.83203-0.99609-1.4102-1.8633-1.4062z"></path>  <path d="m88.859 43.367-6.5977 1.3203h0.003906c-2.457 0.48828-4.3945 2.3828-4.9375 4.8281l-1.1016 4.957h1.7734c1.582 0 3 0.97656 3.5664 2.457l1.4219 0.71094c0.13281 0.066406 0.21484 0.20312 0.21484 0.35156-0.003906 2.8008-2.2734 5.0742-5.0781 5.0781h-1.1719v2.1641h17.969v-26.164c-1.3203 2.2266-3.5234 3.7852-6.0625 4.2969z"></path>  <path d="m82.414 58.227-1.3398-0.67187v0.003906c-0.09375-0.050782-0.16406-0.13281-0.19922-0.23438-0.41406-1.2383-1.5742-2.0703-2.875-2.0664h-3c-0.12891 0-0.25391-0.066406-0.32422-0.17578l-2.125-3.1875c-0.0625-0.09375-0.17578-0.13672-0.28516-0.10938-0.10938 0.023438-0.1875 0.11719-0.20312 0.22656l-1.3633 12.27c-0.015625 0.14844-0.11328 0.27734-0.25391 0.32812l-10.031 3.582c-3.3906 1.2148-6.3203 3.4453-8.3906 6.3867-2.0742 2.9414-3.1914 6.4531-3.1953 10.051v7.5586c0 0.10156-0.042969 0.20312-0.11719 0.27734-0.074219 0.070312-0.17188 0.11328-0.27734 0.11328-1.8398-0.011719-3.6016-0.75391-4.8906-2.0625-1.168-1.207-1.7969-2.832-1.7422-4.5078 0.042969-1.6758 0.73047-3.2695 1.918-4.4531l1.1289-1.1289c1.0117-1.0078 1.5977-2.3672 1.6367-3.7969 0.039063-1.5781-0.59766-3.0977-1.7578-4.1719-1.1133-1.0273-2.5781-1.5898-4.0938-1.5742h-1.5273c-0.60156-0.011718-1.1211 0.42969-1.207 1.0273-0.042969 0.33203 0.0625 0.66797 0.28516 0.92188 0.22266 0.25 0.54297 0.39453 0.87891 0.39453h1.8281c0.9375 0 1.8281 0.40234 2.4414 1.1055 0.61719 0.70312 0.90234 1.6367 0.78125 2.5664-0.10547 0.73047-0.44922 1.4023-0.97656 1.9219l-1.0781 1.0742c-1.5781 1.5742-2.5039 3.6836-2.5977 5.9102-0.10938 2.3242 0.73828 4.5898 2.3438 6.2695 1.7383 1.8047 4.1289 2.8281 6.6367 2.8438h0.035156 15.547l-0.003907 0.003906c0.59766 0.007813 1.1133-0.42578 1.2031-1.0195 0.042969-0.33594-0.058594-0.67188-0.28125-0.92578-0.22266-0.25-0.54297-0.39844-0.87891-0.39844h-12.48c-0.19531 0.003906-0.36719-0.13281-0.40625-0.32422-0.019531-0.11328 0.015625-0.23047 0.089844-0.32031 0.074219-0.085938 0.18359-0.13672 0.29688-0.13672h9.2539l3.2344-2.2539h-0.003906c2.3672-1.7812 3.332-4.875 2.3984-7.6875-0.93359-2.8125-3.5586-4.7148-6.5234-4.7266-0.19531 0.007813-0.37109-0.12891-0.41016-0.32031-0.019531-0.11719 0.011719-0.23047 0.085937-0.32031 0.074219-0.089843 0.18359-0.14062 0.30078-0.14062 4.2383 0.007813 7.6758 3.4414 7.6797 7.6836 0 0.47266-0.046875 0.94531-0.13281 1.4141l1.6797-1.3516-0.003906-0.003906c0.12109-0.078125 0.27344-0.085938 0.40234-0.015625 0.125 0.066406 0.20312 0.19922 0.20312 0.34375l0.97656 10.113c0 0.10547 0.042969 0.20312 0.11328 0.27734 0.074219 0.070312 0.17188 0.11328 0.27734 0.11328h3.5703c0.45703 0.007813 0.84766-0.32422 0.91406-0.77344 0.027344-0.21484-0.027344-0.43359-0.14844-0.60938-0.10156-0.14844-0.24219-0.26172-0.41016-0.32422l-1.7227-0.66406c-0.15234-0.058593-0.25-0.20312-0.25-0.36328v-10.871c0-0.09375 0.035156-0.18359 0.09375-0.25391 1.957-2.3242 3.0312-5.2617 3.0312-8.3008v-10.082c0-0.21875 0.17578-0.39063 0.39062-0.39063h1.5625c2.2812-0.003906 4.1602-1.7852 4.2891-4.0625z"></path>  <path d="m67.488 91.469-2.3594-1.1797c-0.14844-0.074218-0.23438-0.23437-0.21094-0.39844l0.007812-0.054687c-0.13672 0.11719-0.27344 0.23437-0.41797 0.33984l-2.3281 1.6211h1.8828c0.74219 0 1.418 0.41797 1.75 1.0781 0.32812 0.66406 0.25391 1.457-0.19141 2.0469h1.0508c1.0078 0 1.8242-0.81641 1.8242-1.8242-0.003906-0.69141-0.39062-1.3203-1.0078-1.6289z"></path>  <path d="m38.68 85.773c0.10156-2.4219 1.1133-4.7188 2.8281-6.4297l1.0781-1.0742c0.40625-0.39453 0.66797-0.91406 0.75391-1.4727 0.09375-0.70312-0.125-1.4141-0.59375-1.9492s-1.1445-0.83984-1.8555-0.83984h-1.8281c-1.0781 0-1.9531-0.875-1.9531-1.9531 0-1.082 0.875-1.9531 1.9531-1.9531h1.6953c0.058594 0 0.11328 0.003907 0.17188 0.003907-1.9688-0.96484-4.0352-1.7109-6.1641-2.2266v27.043h9.8555c-1.2773-0.52344-2.4297-1.3086-3.3828-2.3086-1.75-1.832-2.6758-4.3047-2.5586-6.8398z"></path> </svg>
                    <span>Technicians</span><span class="tooltip">Technicians</span><i>{this.state.technicianlist.length}</i></li>

                  <li onClick={() => this.handleClick('pastappointment')} className={activetab === 'pastappointment' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg>
                  <span>Past Appointments</span><span class="tooltip">Past Appts</span><i>{this.state.pastappointmentcount?this.state.pastappointmentcount:0}</i></li>
                  

                 

                    <li onClick={() => this.handleClick('ongoingappts')} className={activetab === 'ongoingappts' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg> */}
                    <svg viewBox="3.9 2.5 92.2 95"><switch><g><path d="M25.9,19h5.1c1.5,0,2.7-1.2,2.7-2.7V5.2c0-1.5-1.2-2.7-2.7-2.7h-5.1c-1.5,0-2.7,1.2-2.7,2.7v11.2     C23.2,17.8,24.4,19,25.9,19z"></path><path d="M59,19h5.1c1.5,0,2.7-1.2,2.7-2.7V5.2c0-1.5-1.2-2.7-2.7-2.7H59c-1.5,0-2.7,1.2-2.7,2.7v11.2C56.4,17.8,57.6,19,59,19z"></path><path d="M86,22.3c0-6.5-5.3-11.8-11.8-11.8h-2.2v5.8c0,4.4-3.6,8-8,8H59c-4.4,0-8-3.6-8-8v-5.8H39v5.8c0,4.4-3.6,8-8,8h-5     c-4.4,0-8-3.6-8-8v-5.8h-2.2c-6.5,0-11.8,5.3-11.8,11.8v8.6H86V22.3z"></path><path d="M75.2,50.4c3.9,0,7.6,0.8,10.9,2.4V36.2H3.9v35.6c0,6.5,5.3,11.8,11.8,11.8h34.2c-0.6-2.2-1-4.6-1-7     C48.9,62.1,60.7,50.4,75.2,50.4z"></path><path d="M75.2,55.7c-11.5,0-20.9,9.4-20.9,20.9s9.4,20.9,20.9,20.9c11.5,0,20.9-9.4,20.9-20.9S86.7,55.7,75.2,55.7z M83.3,79.3     h-8.1c-1.5,0-2.7-1.2-2.7-2.7V64.8c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v9.1h5.4c1.5,0,2.7,1.2,2.7,2.7     C86,78.1,84.8,79.3,83.3,79.3z"></path></g></switch></svg>
                    <span>Ongoing Appointments</span><span class="tooltip">Ongoing Appts</span><i>{this.state.ongoingapptscount?this.state.ongoingapptscount:0}</i></li>

                    <li onClick={() => this.handleClick('futureappts')} className={activetab === 'futureappts' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg>
                    <span>Future Appointments</span><span class="tooltip">Future Appts</span><i>{this.state.futureapptscount?this.state.futureapptscount:0}</i></li>

                    <li onClick={() => this.handleClick('recommendedlist')} className={activetab === 'recommendedlist' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="3 4 58 56"><rect x="3" y="58" width="58" height="2"></rect><path d="m7,40c-.55,0-1,.45-1,1v14c0,.55.45,1,1,1h14c.55,0,1-.45,1-1v-14c0-.55-.45-1-1-1H7Zm9,8l-2-1-2,1v-6h4v6Z"></path><path d="m24,55c0,.55.45,1,1,1h14c.55,0,1-.45,1-1v-14c0-.55-.45-1-1-1h-14c-.55,0-1,.45-1,1v14Zm6-13h4v6l-2-1-2,1v-6Z"></path><path d="m24,37c0,.55.45,1,1,1h14c.55,0,1-.45,1-1v-14c0-.55-.45-1-1-1h-14c-.55,0-1,.45-1,1v14Zm6-13h4v6l-2-1-2,1v-6Z"></path><path d="m43,56h14c.55,0,1-.45,1-1v-14c0-.55-.45-1-1-1h-14c-.55,0-1,.45-1,1v14c0,.55.45,1,1,1Zm5-14h4v6l-2-1-2,1v-6Z"></path><path d="m43,38h14c.55,0,1-.45,1-1v-14c0-.55-.45-1-1-1h-14c-.55,0-1,.45-1,1v14c0,.55.45,1,1,1Zm5-14h4v6l-2-1-2,1v-6Z"></path><path d="m43,20h14c.55,0,1-.45,1-1V5c0-.55-.45-1-1-1h-14c-.55,0-1,.45-1,1v14c0,.55.45,1,1,1Zm5-14h4v6l-2-1-2,1v-6Z"></path></svg>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg> */}
                   <span>Recommended Products</span> <span class="tooltip">Recommended Products</span><i>{this.state.recommendedlist.length}</i></li>

                    <li onClick={() => this.handleClick('RaiseDisputelist')} className={activetab === 'RaiseDisputelist' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg>
                    <span>Raised Disputes</span><span class="tooltip">Raised Disputes</span><i>{this.state.RaiseDisputelist.length}</i></li> 

                    <li onClick={() => this.handleClick('rating')} className={activetab === 'rating' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" x="0px" y="0px" enable-background="new 0 0 100 100" viewBox="10 11.67 80 76.67"><path d="M50,73.099l19.883,14.453c1.367,0.996,3.281,1.074,4.727,0.02c1.445-1.058,1.992-2.881,1.445-4.505l-7.578-23.421  L88.32,45.156v0.039C89.336,44.47,90,43.274,90,41.943c0-2.233-1.797-4.053-4.023-4.053h-24.57l-7.598-23.424  c-0.508-1.602-2.031-2.8-3.809-2.8s-3.301,1.198-3.809,2.8l-7.598,23.424h-24.57l0,0c-2.207,0-4.023,1.819-4.023,4.053  c0,1.331,0.664,2.526,1.68,3.252v-0.02l19.863,14.47c0,0-7.598,23.421-7.578,23.421c-0.547,1.624-0.02,3.447,1.445,4.524  c1.445,1.035,3.34,0.957,4.707-0.039L50,73.099z"></path></svg>
                    <span>Ratings</span><span class="tooltip">Ratings</span><i>{this.state.ratinglist.length}</i></li>

                    <li onClick={() => this.handleClick('revenuehistory')} className={activetab === 'revenuehistory' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    {/* <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="7.81 7.81 84.38 84.37">  <g>   <path d="m7.8125 39.062v43.75c0 5.1719 4.2031 9.375 9.375 9.375h65.625c5.1719 0 9.375-4.2031 9.375-9.375v-43.75zm58.332 22.656-16.145 16.145c-2.2305 2.2305-5.8438 2.2305-8.0742 0l-8.0742-8.0742c-2.2305-2.2305-2.2305-5.8438 0-8.0742 2.2305-2.2305 5.8438-2.2305 8.0742 0l4.0352 4.0352 12.109-12.109c2.2305-2.2305 5.8438-2.2305 8.0742 0s2.2305 5.8438 0 8.0742z"></path>   <path d="m82.812 17.188h-3.125v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-40.625v-4.6875c0-2.5898-2.0977-4.6875-4.6875-4.6875s-4.6875 2.0977-4.6875 4.6875v4.6875h-3.125c-5.1719 0-9.375 4.2031-9.375 9.375v6.25h84.375v-6.25c0-5.1719-4.2031-9.375-9.375-9.375z"></path>  </g> </svg> */}
                    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" x="0px" y="0px" viewBox="9.01 5.51 76.93 83.98"><path d="M42.244,57.576H62.05a4.36,4.36,0,0,1,0,8.719H44.22A1.33,1.33,0,0,0,42.9,67.627v2.82a1.3,1.3,0,0,0,.382.944,1.274,1.274,0,0,0,.935.389l17.851-.051a2.634,2.634,0,0,0,1.339-.357l16.044-9.266a4.36,4.36,0,0,1,4.356,7.553L50.086,89.129a2.554,2.554,0,0,1-2.062.25L27.857,83.531A4.44,4.44,0,0,0,27.878,83V55.752a4.8,4.8,0,0,0-.063-.784A12.3,12.3,0,0,1,40.522,56.94a2.571,2.571,0,0,0,1.722.636ZM61.6,5.509a22.433,22.433,0,1,1-17.3,36.73,17.2,17.2,0,0,0,3.507-3.277,15.841,15.841,0,0,0,1.317,1.453,17.642,17.642,0,1,0,0-24.948,16.256,16.256,0,0,0-1.317,1.454,17.171,17.171,0,0,0-3.507-3.277A22.4,22.4,0,0,1,61.6,5.509ZM34.254,13A14.94,14.94,0,1,0,49.193,27.941,14.943,14.943,0,0,0,34.254,13Zm0,16.21a5.071,5.071,0,0,1-3.592-8.659,5.1,5.1,0,0,1,2.317-1.325V18.185a1.275,1.275,0,0,1,2.55,0v1.043a5.208,5.208,0,0,1,2.316,1.325,5.075,5.075,0,0,1,1.488,3.587,1.276,1.276,0,0,1-2.551,0,2.526,2.526,0,1,0-2.528,2.531,5.071,5.071,0,0,1,3.591,8.659,5.206,5.206,0,0,1-2.316,1.324V37.7a1.275,1.275,0,0,1-2.55,0V36.654a5.075,5.075,0,0,1-3.8-4.911,1.275,1.275,0,0,1,2.55,0,2.526,2.526,0,1,0,2.529-2.531Zm27.349,0a2.9,2.9,0,0,1,2.041.848,2.893,2.893,0,0,1,0,4.1,2.909,2.909,0,0,1-4.1,0,2.952,2.952,0,0,1-.85-2.048,1.257,1.257,0,0,0-1.254-1.271,1.275,1.275,0,0,0-1.275,1.271,5.361,5.361,0,0,0,1.594,3.844,5.292,5.292,0,0,0,2.571,1.441v1.239A1.276,1.276,0,0,0,61.6,39.9a1.257,1.257,0,0,0,1.254-1.271V37.394a5.292,5.292,0,0,0,2.571-1.441A5.438,5.438,0,0,0,61.6,26.671a2.92,2.92,0,0,1-2.061-.846,2.9,2.9,0,0,1,0-4.1,2.912,2.912,0,0,1,4.1,0,2.866,2.866,0,0,1,.85,2.049,1.274,1.274,0,0,0,1.275,1.271,1.256,1.256,0,0,0,1.253-1.271,5.352,5.352,0,0,0-1.594-3.842,5.279,5.279,0,0,0-2.571-1.443V17.25A1.255,1.255,0,0,0,61.6,15.981a1.274,1.274,0,0,0-1.275,1.269v1.239a5.279,5.279,0,0,0-2.571,1.443,5.437,5.437,0,0,0,3.846,9.28ZM72.271,17.263a15.1,15.1,0,0,0-21.357,0,14.235,14.235,0,0,0-1.572,1.853,17.557,17.557,0,0,1,0,17.653,14.284,14.284,0,0,0,1.572,1.851A15.1,15.1,0,0,0,72.271,17.263Zm-48.6,36.8H10.708a1.7,1.7,0,0,0-1.7,1.685V83a1.7,1.7,0,0,0,1.7,1.685H23.671A1.694,1.694,0,0,0,25.35,83V55.752A1.694,1.694,0,0,0,23.671,54.067Z" fill-rule="evenodd"></path></svg>
                    <span>Revenue Histories</span><span class="tooltip">Revenue Histories</span><i>{this.state.revenuelist.length}</i></li>

                     {/* <li onClick={() => this.handleClick('medical_list')} className={activetab === 'medical_list' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="77.38 31.95 345.25 436.1"><path clipRule="evenodd" d="M113.718,31.949c-20.079,0-36.343,16.264-36.343,36.34v363.421  c0,20.078,16.264,36.34,36.343,36.34h272.566c20.079,0,36.34-16.262,36.34-36.34V158.417c0-12.173-4.81-22.982-12.536-30.796  l-82.497-82.319c-8.173-8.265-19.628-13.352-32.164-13.352H113.718z M240.914,95.548c0-9.996,8.177-18.173,18.172-18.173  c9.991,0,18.172,8.177,18.172,18.173v68.14c0,7.542,6.087,13.629,13.626,13.629h68.143c9.99,0,18.172,8.175,18.172,18.17  c0,9.996-8.182,18.171-18.172,18.171h-81.769c-20.079,0-36.344-16.264-36.344-36.341V95.548z" fill="#000000" fillRule="evenodd"></path></svg>
                    Medical History <i>{this.state.medicalHistorylist.length}</i> </li> 

                    <li onClick={() => this.handleClick('medical_condition')} className={activetab === 'medical_condition' ? 'active cursor-pointer' : ' cursor-pointer'}>
                    <svg width="16" xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="77.38 31.95 345.25 436.1"><path clipRule="evenodd" d="M113.718,31.949c-20.079,0-36.343,16.264-36.343,36.34v363.421  c0,20.078,16.264,36.34,36.343,36.34h272.566c20.079,0,36.34-16.262,36.34-36.34V158.417c0-12.173-4.81-22.982-12.536-30.796  l-82.497-82.319c-8.173-8.265-19.628-13.352-32.164-13.352H113.718z M240.914,95.548c0-9.996,8.177-18.173,18.172-18.173  c9.991,0,18.172,8.177,18.172,18.173v68.14c0,7.542,6.087,13.629,13.626,13.629h68.143c9.99,0,18.172,8.175,18.172,18.17  c0,9.996-8.182,18.171-18.172,18.171h-81.769c-20.079,0-36.344-16.264-36.344-36.341V95.548z" fill="#000000" fillRule="evenodd"></path></svg>
                    Medical Condition <i>{this.state.medicalCondition.length}</i> </li>  */}
                
                </ul>
                <div className="vertical-menu-content">

                      <div className={activetab === 'userdetail' ?"content-div userdetail active":"content-div userdetail"} id="userdetail">
                      <div className="title text-start">
                      <h3> Demographics</h3>
                      </div>
                      <div className="form-row">
                        <div className="details_left">
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Username<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.doctorlistview.username}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Name<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.doctorlistview.name}</p>
                              </div>
                            </div>
                           
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Email<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.doctorlistview.email}</p>
                              </div>
                            </div>
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Mobile number<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.doctorlistview.phone?this.state.doctorlistview.phone:'N/A'}</p>
                              </div>
                              
                            </div>

                            {(this.state.doctorlistview.graduation!=''&&this.state.doctorlistview.graduation!=null)&&<div className="view-details">
                              <div className="view-details-one">
                                  <p>Graduation<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.doctorlistview.graduation}</p>
                              </div>                              
                            </div>}

                            {(this.state.doctorlistview.experience_yr!=''&&this.state.doctorlistview.experience_yr!=null)&&<div className="view-details">
                              <div className="view-details-one">
                                  <p>Experience<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>{this.state.doctorlistview.experience_yr}Yrs</p>
                              </div>                              
                            </div>}
                           
                            {(this.state.doctorlistview.consultant_fee!=''&&this.state.doctorlistview.consultant_fee!=0&&this.state.doctorlistview.consultant_fee!=null)&&<div className="view-details">
                              <div className="view-details-one">
                                  <p>Consultant Fees<span>:</span></p>
                              </div>
                              <div className="view-details-two">
                                  <p>${this.state.doctorlistview.consultant_fee}</p>
                              </div>                              
                            </div>}

                            
                            <div className="view-details">
                              <div className="view-details-one">
                                  <p>Location<span>:</span></p>
                              </div>
                            <div className="view-details-two">
                                  <p>{ this.state.doctorlistview.location}</p>
                              </div>
                            </div>



                        </div>
                      </div>
                      </div>
                      
                      

                      <div className={activetab === 'technicianlist' ?"content-div technicianlist active":"content-div technicianlist"} id="technicianlist">
                      <div className="title text-start">                       
                      <h3>Technicians</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>                           
                              <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Email</th>    
                                <th>Phone</th>
                                <th>Experience</th>
                                <th>Location</th>
                              </tr>
                            </thead>
                           <tbody> {this.technicianlist()}<br/>
                            </tbody>
                          </Table>
                          
                        </div>
                      </div>

                      <div className={activetab === 'revenuehistory' ?"content-div revenuehistory active":"content-div revenuehistory"} id="revenuehistory">
                      <div className="title text-start">
                       
                      <h3>Revenue Histories</h3>

                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                           
                              <tr>
                                <th>S.No</th>
                                <th>Earning From</th>
                                <th>ID</th>                              
                                {/* <th>Name</th> */}
                                <th>Earning Amount</th>
                                {/* <th>Settlement</th> */}
                                <th>Earning On</th>
                              </tr>
                            </thead>
                           <tbody> {this.Revenuelist()}<br/>
                            </tbody>
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>
                      <div className={activetab === 'pastappointment' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                       
                      {this.state.ShowPrescriptionlist==true? <h3> Appointment Prescriptions</h3>: <h3>Past Appointment Lists</h3>} 

                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            {this.state.ShowPrescriptionlist==true?
                              <tr>
                              <th>S.No</th>                              
                              <th>Medicine </th>
                              <th>Quantity</th>
                              <th>Price</th>
                            </tr>:
                              <tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Name</th>
                                <th>Pet Name</th>
                                <th>Reason</th>
                              
                                {/* <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th> */}
                                <th>Schedule On</th>
                                <th>Prescription</th>
                              </tr>}
                            </thead>
                            {this.state.ShowPrescriptionlist==true?<tbody> {this.apptPrescriptionlist()}<br/>
                            </tbody>:
                            <tbody> {this.pastappointment()}<br/>
                            
                            </tbody>}
                          </Table>
                          <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.pastappointmentcount}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this,'past')}
                            />
                          </div> 
                        </div>
                      </div>

                      <div className={activetab === 'ongoingappts' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                      {this.state.ShowPrescriptionlist==true? <h3> Appointment Prescriptions</h3>: <h3>Ongoing Appointments</h3>}
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            {this.state.ShowPrescriptionlist==true?
                              <tr>
                              <th>S.No</th>                              
                              <th>Medicine </th>
                              <th>Quantity</th>
                              <th>Price</th>
                            </tr>:<tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Name</th>  
                                <th>Pet Name</th>
                                <th>Reason</th>
                              
                                {/* <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th> */}
                                <th>Schedule On</th>
                                <th>Prescription</th>
                              </tr>}
                            </thead>
                            {this.state.ShowPrescriptionlist==true?<tbody> {this.apptPrescriptionlist()}<br/>
                            </tbody>:
                            <tbody> {this.ongoingappts()}<br/>
                            </tbody>}
                          </Table>
                          <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.ongoingapptscount}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this,'ongoing')}
                            />
                          </div> 
                        </div>
                      </div>


                      <div className={activetab === 'futureappts' ?"content-div appointments active":"content-div appointments"} id="appointments">
                      <div className="title text-start">
                     <h3>Future Appointments</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            
                              <tr>
                                <th>S.No</th>
                                <th>Appt ID</th>
                                <th>Name</th>
                                <th>Pet Name</th>
                                <th>Reason</th>
                               
                                {/* <th>Gender</th>
                                <th>Mobile</th>
                                <th>Status</th> */}
                                <th>Schedule On</th>
                                {/* <th>Action</th> */}
                              </tr>
                            </thead>                           
                            <tbody> {this.futureappts()}<br/>
                            </tbody>
                          </Table>
                          <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.futureapptscount}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this,'future')}
                            />
                          </div> 
                        </div>
                      </div>

                      <div className={activetab === 'recommendedlist' ?"content-div recommendedlist active":"content-div recommendedlist"} id="recommendedlist">
                      <div className="title text-start">
                     <h3>Recommended Products</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                            
                           
                                {this.state.ShowRecommendedProduct==true?
                                <tr>
                                <th>S.No</th>
                                <th>Name </th>
                                <th>Category </th>
                                <th>Image </th>
                                <th>Single Price </th>
                                <th>Qty</th>                              
                                <th>Total </th>
                                </tr>
                                :
                                <tr>
                                <th>S.No</th>
                                <th>User </th>
                                <th>Products </th>
                                <th>Amount </th>
                                <th>Payment Paid </th>
                                <th>Recommended On </th>                              
                                <th>Action</th>
                              </tr>}
                            </thead>                           
                            <tbody> {this.state.ShowRecommendedProduct==true? this.recommendedProductlist():this.recommendedlist()}<br/>
                            </tbody>
                          </Table>
                          {/* <div className="text-center">
                            <Pagination
                            activePage={this.state.activePage}
                            itemsCountPerPage={10}
                            totalItemsCount={this.state.totalRecord}
                            pageRangeDisplayed={5}
                            onChange={this.handlePageChange.bind(this)}
                            />
                          </div> */}
                        </div>
                      </div>
                      

                        <div className={activetab === 'RaiseDisputelist' ?"content-div RaiseDisputelist active":"content-div RaiseDisputelist"} id="RaiseDisputelist">
                      <div className="title text-start">
                        <h3>Raised Disputes</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Dispute</th>
                                <th>Appt ID</th>
                                <th>User</th>
                                <th>Comment</th>
                              
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.RaiseDisputelist()}<br/>
                            
                            </tbody>
                          </Table>
                         
                        </div>
                      </div> 

                      <div className={activetab === 'rating' ?"content-div  active":"content-div rating"} id="rating">
                      <div className="title text-start">
                        <h3> Ratings</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                               
                                <th>Appt ID</th>
                                <th>User</th>
                                <th>Rating</th>
                                <th>Comment</th>
                                <th>Rating On</th>
                              </tr>
                            </thead>
                            <tbody> {this.Ratinglist()}<br/>
                            
                            </tbody>
                          </Table>
                         
                        </div>
                      </div>

                      {/*<div className={activetab === 'medical_list' ?"content-div medical_list active":"content-div medical_list"} id="medical_list">
                      <div className="title text-start">
                        <h3>Medical History</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>File</th>
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.medicalHistory()}<br/>
                            
                            </tbody>
                          </Table>
                         
                        </div>
                      </div>

                      <div className={activetab === 'medical_condition' ?"content-div medical_condition active":"content-div medical_condition"} id="medical_condition">
                      <div className="title text-start">
                        <h3>Medical Condition</h3>
                      </div>
                      <div className="car-listing-row">
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Medical Condition</th>
                                <th>Uploaded On</th>
                              </tr>
                            </thead>
                            <tbody> {this.medicalCondition()}<br/>                            
                            </tbody>
                          </Table>                         
                        </div>
                      </div> */}
                   
                </div>
              </div>
             
                  
              </div>            
            
          </div>
         </div> 
        </div>        
    </div>
    );
  }
}

export default (withRouter(ViewEMR));